module.exports = __webpack_public_path__ + "static/media/photography-helpful.d51b5c00.svg";